const staff = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Staff',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4 pt-4",
                "children": [
                    {
                        "title": "Settings",
                        "service": "category",
                        "type": "",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "addNewSuccessTitle": 'Category Added!',
                            "addNewSuccessMessage": 'Category Added Successfully!',
                            "addNewErrorTitle": 'Category Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Category Deleted!',
                            "deleteSuccessMessage": 'Category Deleted Successfully!',
                            "deleteErrorTitle": 'Category Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Category Activated!',
                            "activeSuccessMessage": 'Category Activated Successfully!',
                            "activeErrorTitle": 'Category Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "descriptionTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "load_url": "/api/cms/$currentCmsId/categories",
                                    "submit_url": "/api/cms/$currentCmsId/categories?where=%7B%22id%22%3A%22$currentCategoryId%22%7D",
                                    "form": {
                                        "text": {
                                        "inside": ['additionalProp1', 'description', 'text'],
                                        "type": 'ckeditor',
                                        "label": 'Page Description',
                                        "placeholder": 'Enter Description',
                                        "required": false,
                                        "info": true,
                                        "character_count": 1000,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },
                        ]
                    },
                    {
                        "title": "Groups",
                        "service": "categoryGroups",
                        "type": "",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": true,
                            "deleteButton": false, 
                            "addNewSuccessTitle": 'Group Added!',
                            "addNewSuccessMessage": 'Group Added Successfully!',
                            "addNewErrorTitle": 'Group Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Group Deleted!',
                            "deleteSuccessMessage": 'Group Deleted Successfully!',
                            "deleteErrorTitle": 'Group Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Group Activated!',
                            "activeSuccessMessage": 'Group Activated Successfully!',
                            "activeErrorTitle": 'Group Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Group Updated!',
                            "updateSuccessMessage": 'Group Updated Successfully!',
                            "updateErrorTitle": 'Group Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Group",
                                "variant": "add",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Group Name',
                                    "placeholder": 'Enter Group Name',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                },
                                "additionalProps": {
                                    "active": true,
                                    // "subgroups": [],
                                }
                            }
                        },
                        "children": [
                            {
                                "type": "groupsTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Group",
                                    "type": "groupList",
                                    "info": true,
                                    "size": "4",
                                    "style": "",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ]
                                },
                            "form": {
                                    "title": "Tab Two",
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "submit_url": "/api/pages/$currentPageId",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Group Name',
                                            "placeholder": 'Enter Group Name',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "description": {
                                            "type": 'ckeditor',
                                            "label": 'Description',
                                            "placeholder": 'Enter Description',
                                            "required": false,
                                            "info": true,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        // "subgroups": {
                                        //     "type": 'subgroup',
                                        //     "label": 'Sub-groups',
                                        //     "placeholder": 'Enter Subgroup',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "address": {
                                        //     "type": 'text',
                                        //     "label": 'Address',
                                        //     "placeholder": 'Enter Address',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 250,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "date": {
                                        //     "type": 'date',
                                        //     "label": 'Date',
                                        //     "placeholder": 'Enter Date',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                    },
                                    "children": [
                                    ]
                                }
                            },

                        ]
                    },
                    {
                        "title": "Team",
                        "service": "pages",
                        "type": "",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": true,
                            "activeToggle": true,
                            "deleteButton": true, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Member",
                                "variant": "add",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Member Name',
                                    "placeholder": 'Enter Member Name',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                    "group": {
                                        "type": 'groupSelect',
                                        "label": 'Group',
                                        "placeholder": 'Select Group',
                                        "load_url": '',
                                        "required": false,
                                        "info": false,
                                        "character_count": 0,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                    },
                                    // "subgroup": {
                                    //     "type": 'subgroupSelect',
                                    //     "label": 'Sub-Group',
                                    //     "placeholder": 'Select Sub-Group',
                                    //     "load_url": '',
                                    //     "required": false,
                                    //     "info": false,
                                    //     "character_count": 0,
                                    //     "disabled": false,
                                    //     "class": '',
                                    //     "size": "6",
                                    //     "style": ""
                                    // },
                                },
                                "additionalProps": {
                                    "role": '',
                                    "group": '',
                                    "subgroup": '',
                                    "locations": '',
                                    "qualifications": '',
                                    "availability": {
                                        'locations':  []
                                    },
                                    "gender": {
                                        'name':  'Male'
                                    },
                                }
                            }
                        },
                        "children": [
                            {
                                "type": "membersTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                        "label": "Member",
                                        // "type": "list",
                                        "type": "list",
                                        "variant": "filtered",
                                        "filter": "groups",
                                        "withoutSubGroups": true,
                                        "filterOn": "group",
                                        "info": true,
                                        "size": "4",
                                        "style": "",
                                        "class": "p-0 pt-3 pr-3",
                                        "load_url": "/api/categories/$currentCategoryId/pages",
                                        "draggable": true,
                                        "children": [
                                        ]
                                    },
                                "form": {
                                        "title": "Tab Two",
                                        "type": "form",
                                        "variant": "patch",
                                        "size": "8",
                                        "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                        "class": "pl-4 pt-3",
                                        "submit_url": "/api/pages/$currentPageId",
                                        "form": {
                                            "title": {
                                                "type": 'text',
                                                "label": 'Name',
                                                "placeholder": 'Enter Member Name',
                                                "required": true,
                                                "info": true,
                                                "character_count": 250,
                                                "disabled": false,
                                                "class": '',
                                                "size": "12",
                                                "style": ""
                                            },
                                            "role": {
                                                "type": 'text',
                                                "label": 'Role',
                                                "placeholder": 'Enter Role',
                                                "required": true,
                                                "info": true,
                                                "character_count": 250,
                                                "disabled": false,
                                                "class": '',
                                                "size": "12",
                                                "style": ""
                                            },
                                            "qualifications": {
                                                "type": 'text',
                                                "label": 'Qualifications',
                                                "placeholder": 'Enter Qualifications',
                                                "required": true,
                                                "info": true,
                                                "character_count": 250,
                                                "disabled": false,
                                                "class": '',
                                                "size": "12",
                                                "style": ""
                                            },
                                            "gender": {
                                                "type": 'radioObject',
                                                "label": 'Gender',
                                                "placeholder": 'Select Gender',
                                                "required": false,
                                                "info": true,
                                                "character_count": 0,
                                                "disabled": false,
                                                "class": '',
                                                "size": "12",
                                                "style": "",
                                                "options": [
                                                    {
                                                      "name": 'Male',
                                                    },
                                                    {
                                                      "name": 'Female',
                                                    }
                                                  ]                                    
                                            },
                                            "picture": {
                                                "type": 'imgSelect',
                                                "label": 'Photo',
                                                "placeholder": 'Select Image',
                                                "load_url": '',
                                                "required": false,
                                                "info": false,
                                                "character_count": 0,
                                                "disabled": false,
                                                "class": '',
                                                "size": "6",
                                                "style": ""
                                            },
                                            "group": {
                                                "type": 'groupSelect',
                                                "label": 'Group',
                                                "placeholder": 'Select Group',
                                                "inside": ['additionalProp1', 'group'],
                                                "load_url": '',
                                                "required": false,
                                                "info": false,
                                                "character_count": 0,
                                                "disabled": false,
                                                "class": '',
                                                "size": "6",
                                                "style": ""
                                            },
                                            "description": {
                                                "type": 'ckeditor',
                                                "label": 'Description',
                                                "placeholder": 'Enter Description',
                                                "required": false,
                                                "info": true,
                                                "character_count": 2000,
                                                "disabled": false,
                                                "class": '',
                                                "size": "12",
                                                "style": ""
                                            },
                                        },
                                        "children": [
                                        ]
                                    }
                            },
                        ]
                    },
                ]
            }
        ]
    }
]

export { staff };